import { gql } from '@/__generated__';

const GET_DEVICE_PROFILE_ALERT_TRIGGERS = gql(`#graphql
  query DeviceProfile_GetAlertTriggers($deviceId: ID!, $alertType: AlertTypeId!) {
    alertsNotifications {
      history(
        input: { deviceIds: [$deviceId], alertTypes: [$alertType] }
        pagination: { limit: 3 }
      ) {
        nodes {
          alertType
          id
          successRate
          timestamp
        }
      }
    }
  }
`);

export default GET_DEVICE_PROFILE_ALERT_TRIGGERS;

